/**
 * Component Registry for Casa Madrid 
 * 
 * Inherits from @vibesites-sunrise-management/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-sunrise-management/theme-preferred/registry';
import { Reviews } from './components/Reviews';
import { NeighborhoodCallout } from './components/NeighborhoodCallout';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Example: Override the Footer with a custom component
  // Footer: Footer,
  Reviews,
  NeighborhoodCallout,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
